import AirportInput from "./AirportInput";
import { changeDestinationAirport } from "../searchFlightsSlice";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { faPlaneArrival } from "@fortawesome/free-solid-svg-icons/faPlaneArrival";
import { useTranslation } from "react-i18next";

function DestinationAirportInput() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const destinationAirport = useAppSelector(
    (state) => state.searchFlights.form.destinationAirport
  );
  const destinationAnywhere = useAppSelector((state) => state.searchFlights.form.destinationAnywhere);
  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);
  const originAirport = useAppSelector((state) => state.searchFlights.form.originAirport);
  const allowSameDestination = useAppSelector((state) => state.config.mapper.allowSameDestination);
  const validity = useAppSelector((state) => state.searchFlights.formValidity.destinationAirport);

  const onSelect = (suggestion) => {
    if (!allowSameDestination && suggestion.port.code === originAirport?.port.code) {
      dispatch(changeDestinationAirport(null));
      return;
    }
    dispatch(changeDestinationAirport(suggestion));
  };

  return (
    <AirportInput
      id="destination-airport-input"
      airport={destinationAirport}
      validity={validity}
      validityMessage={t("SEARCH_ALERT_DESTINATION_AIRPORT")}
      icon={faPlaneArrival}
      label={t("INPUT_LABEL_TO")}
      placeholder={`${t("INPUT_SELECT_ARRIVAL_AIRPORT")}`}
      title={t("DESTINATION_SEARCH_TITLE")}
      onSelect={onSelect}
      disabled={destinationAnywhere || destinationAirport?.readOnly || disabled}
      {...(!allowSameDestination && { excludeAirport: originAirport })}
    />
  );
}

export default DestinationAirportInput;
